import React from "react";
import PropTypes from "prop-types";
import "css/TickList.css";

const propTypes = {
    upgradeExtra:PropTypes.object.isRequired
};

const UpgradePopup = ({ upgradeExtra }) => (
    <div
        dangerouslySetInnerHTML={{
            __html: upgradeExtra.upgradePopupHtml.replace(
                /<div.*?><div.*?>.<\/div>(.*)<\/div>/g,
                "$1"
            )
        }}
    />
);

UpgradePopup.propTypes = propTypes;

UpgradePopup.defaultProps = {};

export default UpgradePopup;



// WEBPACK FOOTER //
// ./src/components/UpgradePopup.js